<template>
  <div id="app" style="position:relative;">

    <top-countdown :date="countdown" style="position:relative;" v-if="true"></top-countdown>

    <navbar-overlay class="navbar-overlay" v-if="!isPrint && $route.name != 'staytuned' && $route.name != 'notfound'"></navbar-overlay>
    <top-section v-if="!isPrint && $route.name != 'staytuned' && $route.name != 'notfound'"></top-section>

    <router-view class="page-wrapper">
    </router-view>

    <div class="contact-info" v-if="!isPrint && $route.name != 'staytuned' && $route.name != 'notfound'">
      <div-container data-aos="fade-in" data-aos-once="true">
        <div class="columns is-gapless is-centered is-multiline is-flex-mobile">

          <div class="column is-6 is-12-mobile">
            <contact-section data-aos="fade-in" data-aos-once="true" data-aos-duration="1000"></contact-section>
          </div>

          <div class="column is-1 is-12-mobile wrapper is-hidden-mobile">
          </div>

          <div class="column is-5 is-12-mobile wrapper">

            <div class="columns is-gapless is-centered is-multiline is-hidden-mobile" style="margin-bottom:1em;">
              <div class="column is-12 has-text-left">
                <div class="cont-desc" data-aos="fade-in" data-aos-once="true">
                  <h3 class="title" style="font-size:2.6em;">&nbsp;</h3>
                </div>
              </div>
            </div>

            <div class="columns is-gapless is-centered is-multiline">
              <div class="column is-12 has-text-left">

                <div class="item">
                  <div>
                    <b>Fundraising / Vending / Event Coordinating</b>
                  </div>
                  <div>
                    Nan Lynch or Lindsey Beazley Keller • (706) 554-8100
                  </div>
                </div>
                <div class="item">
                  <div>
                    <b>Team Registration</b>
                  </div>
                  <div>
                    Elizabeth Billips • (706) 551-0729
                  </div>
                </div>
                <div class="item">
                  <div>
                    <b>Judges Signup</b>
                  </div>
                  <div>
                    Tim Lively • (706) 551-2045
                  </div>
                </div>
                <div class="item">
                  <a :href="navLocation.path" target="_blank"><img src="./assets/ic_pin.svg" width="40" style="width:40px;float:left;margin-right:15px;" /></a>
                  <div>
                    <b>Boss Hog Cook-Off</b>
                  </div>
                  <div>
                    <a :href="navLocation.path" target="_blank" style="color:#390e07;">{{ navLocation.title }}</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div-container>
    </div>

    <footer-main v-if="!isPrint && $route.name != 'staytuned' && $route.name != 'notfound'"></footer-main>
  </div>
</template>

<script>
import DivContainer from '@/components/DivContainer'

import NavbarFull from '@/components/NavBarFull.vue'
import NavbarOverlay from '@/components/NavBarOverlay.vue'
import TopSection from '@/components/TopSection.vue'
import FooterMain from '@/components/Footer.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ContactSection from '@/pages/ContactSection.vue'
import TopCountdown from '@/pages/TopCountdown.vue'

import EventBus from '@/controllers/EventBus'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app',
  components: {
    DivContainer,
    NavbarFull,
    NavbarOverlay,
    TopCountdown,
    TopSection,
    ContactSection,
    FooterMain,
    PulseLoader
  },
  data () {
    return {
      isDesktop: true,
      isPrint: false,
      navLocation: EventBus._data._navLocation
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    countdown: function () {
      return EventBus.info.countdown
    }
  },
  methods: {
    sample (data) {

    },
    // http://redux.js.org/docs/recipes/UsingObjectSpreadOperator.html
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
    /* global window */
    window.onLoadCallback = function () {
      console.log('callback function here...')
    }
  },
  created () {
    // console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })

    // on master event resize (propagating to EventBus)
    EventBus.isDesktop = (window.innerWidth >= 768)
    EventBus.windowWidth = (window.innerWidth)
    window.addEventListener('resize', function (event) {
      EventBus.isDesktop = (event.target.innerWidth >= 768)
      EventBus.windowWidth = (window.innerWidth)
    })

    if (this.$route.query) {
      if (this.$route.query.print && this.$route.query.print === 'true') {
        this.isPrint = true
      } else {
        this.isPrint = false
      }
    } else {
      this.isPrint = false
    }
  },
  beforeMount () {
    // console.log('beforeMount App.vue')
    window.addEventListener('load', () => {
    })
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "./styles/app_setting.scss";

html.modal-open {
  overflow: hidden;
  position: relative;
  height: 100%;
  body {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
}

body, .page-wrapper {
  background-color: $color-beige;
}

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-darkbrown;

  // // adding countdown on top
  // .navbar-overlay {
  //   top: 43px !important;
  //   @media screen and (min-width: $desktop) {
  //     top: 43px !important;
  //   }
  // }

  .contact-info {
    background-color: $color-orange;

    .wrapper {
      margin-top: 5em;
      margin-bottom: 1em;
      padding: 0 0.75rem;

      @media screen and (min-width: $desktop) {
        padding: 0 0.75rem;
      }

      .item {
        margin-bottom: 2em;
        font-family: $font-family;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?7c2f236e